import React, { useEffect, useState } from "react";
import { FaMoon, FaSun } from "react-icons/fa";

const ThemeToggle = () => {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    // On mount, check localStorage or the system preference
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) {
      setTheme(storedTheme);
      if (storedTheme === "dark") {
        document.documentElement.classList.add("dark");
      }
    }
  }, []);

  const toggleTheme = () => {
    if (theme === "light") {
      document.documentElement.classList.add("dark");
      setTheme("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      setTheme("light");
      localStorage.setItem("theme", "light");
    }
  };

  return (
    <button
      onClick={toggleTheme}
      className={`flex items-center justify-center w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-full shadow-md transition-colors duration-300 focus:outline-none`}
      title="Toggle Light/Dark Mode"
    >
      {theme === "light" ? (
        <FaMoon className={`text-gray-800 text-xl`} />
      ) : (
        <FaSun className={`text-yellow-400 text-xl`} />
      )}
    </button>
  );
};

export default ThemeToggle;